module.exports = __webpack_public_path__ + "img/vertical_4_4_9005.017aa141.png";